<template>
  <footer>
    <div class="container">
      <img
        class="footer-logo"
        src="https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/logos/getty-G-circle-white.svg"
      />

      <p>
        &#169; {{ new Date().getFullYear() }} Getty Images
      </p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
footer {
  padding: 40px;
  color: #fff;
  text-align: center;
  background-color: var(--primary-color);
}
.footer-logo {
  width: 95px;
  margin-bottom: 10px;
}
p {
  font-size: 12px;
}
</style>